import type { FaireProductEntity } from "../../entity_types/product";

export const p_f4f9ujr2m2: FaireProductEntity = {
  token: "p_f4f9ujr2m2",
  type: "product",
  name: "What A Wonderful Day Small Notepad",
  brandName: "Sugarboo & Co",
  imageUrl:
    "https://cdn.faire.com/fastly/87ec079fad6fce9273ddf4cced45737a7ac8a50471ff212ef6f8c81e4870abb1.jpeg",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5ae22639aaeff650bcc0193cfbae5f26c69f3c1087674c899d0fdcbf658612a3.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
